import { render } from "./cloud-notifications.vue?vue&type=template&id=54252044&scoped=true&ts=true"
import script from "./cloud-notifications.vue?vue&type=script&lang=ts"
export * from "./cloud-notifications.vue?vue&type=script&lang=ts"

import "./cloud-notifications.vue?vue&type=style&index=0&id=54252044&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54252044"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
